import ar from "./ar";
import en from "./en";

/*
 * sarwa translations live outside the shared dictionary so only this
 * feature's pages download them.
 */
export const sarwaTextByLocale = { ar, en };

export function getSarwaText(locale) {
  return sarwaTextByLocale[locale] ?? sarwaTextByLocale.ar;
}
